import { Dispatch, ReactNode, useEffect } from 'react'

export const ComboboxItem = ({
  setHovered,
  index,
  active = false,
  children,
}: {
  setHovered: Dispatch<number>
  index: number
  active: boolean
  children: ReactNode
}) => {
  useEffect(() => {
    if (active) {
      setHovered?.(index)
    }
  }, [active])

  return <>{children}</>
}
